<template>
  <app-base-main no-padding parentTable>
    <template #filter-group>
      <app-filter-group :reset="false" :query="false" style="margin-top: 10px" v-if="messageType !== 'operation'">
        <gj-button :loading="markLoading" @click="batchMarkMsg" type="primary" :disabled="checkChecked()">标记已读
        </gj-button>
      </app-filter-group>
      <app-filter-group :reset="false" @query="$gjNoticeQuery" style="margin-top: 10px" v-else>
        <gj-radio-group
            v-if="clientWidth > 1366"
            v-model="filter.hasRead"
            :options="statusList"
            style="width: 172px"
            @input="$gjNoticeQuery()"
        ></gj-radio-group>
        <gj-select v-else
                   v-model="filter.hasRead"
                   :options="statusList"
                   width="100px"
                   @input="$gjNoticeQuery()"
                   :clearable="false">
        </gj-select>
        <gj-country-server-select v-model="filter.countryMarketValue"></gj-country-server-select>
        <gj-select
            v-model="filter.warnTypeCodeList"
            :options="warningTypeList"
            placeholder="预警类型"
            type="multi-check"
            width="150px"
            @change="changeType"
        ></gj-select>
        <gj-select
            v-model="filter.warnTitleCodeList"
            :options="warningTitleList"
            placeholder="预警标题"
            type="multi-check"
            width="150px"
        ></gj-select>
        <gj-input v-model="filter.content" :width="'150px'" placeholder="预警内容搜索"></gj-input>
        <template #right>
          <gj-tool-group help></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>

      <div class="flex align-center justify-between" v-if="messageType !== 'operation'">
        <div>
          <template v-if="messageType === 'account'">
            <gj-popover
                v-model="accountVisible"
                @close="closeFilterPopover"
            >
              <template slot="reference">
                <gj-icon
                    iconfont="iconguolv" class="iconfont-style"
                ></gj-icon>
              </template>
              <div style="line-height: 2">
                <el-checkbox @change="changeAll" v-model="checkAll" :indeterminate="checkIndeterminate">全选</el-checkbox>
                <el-checkbox-group v-model="filterChecked" @change="changeCheckbox">
                  <template v-for="item in filterCheckedOption">
                    <div :key="item.id">
                      <el-checkbox :label="item.id">
                        {{ item.text }}
                      </el-checkbox>
                    </div>
                  </template>
                </el-checkbox-group>
              </div>
            </gj-popover>
          </template>
          <span class="filter">过滤方式：</span>
          <a class="filter-a" @click="clickStatus">{{ statusFlag ? '所有' : '未读' }}</a>
        </div>
        <gj-button type="text" @click="routerMsg('/message/message-setting')">消息设置</gj-button>
      </div>


      <div class="message-warp" :class="{'border': messageType !== 'operation'}">
        <div :class="[messageType !== 'operation'?'message-account':'message-operation']"
             class="message-middle"
             v-loading="loading">
          <template v-if="isMeaningful(data) && data.length > 0">

            <!--            非运营消息类型-->
            <template v-if="messageType !== 'operation'">
              <el-checkbox-group v-model="checkedMsg" @change="handleCheckItem">
                <div :key="index" v-for="(item, index) in data"
                     class="list-item" :style="{background: checkItem && item.id === checkItem.id ? '#f2f2f2' : ''}"
                     @click="changeItem(item)"
                >
                  <div class="list-checkbox" @click.stop="() => ({})">
                    <el-checkbox style="position: relative; top: 10px;" :label="item">{{ '' }}</el-checkbox>
                  </div>
                  <div class="list-content">
                    <div style="margin-bottom: 4px">
                      <span class="read-radio" :style="{background: item.isRead ? '' : '#1F6EEF'}"></span>
                      <span class="label">{{ _.get(item, "bizType.desc", "-") }}</span>
                      <span class="label"
                            style="float: right; margin-right: 20px">{{
                          convertToFullDate(new Date(item.createTime), 'yyyy/MM/dd')
                        }}</span>
                    </div>
                    <div style="padding-left: 26px; font-size: 12px" class="text-ellipsis-1" v-html="item.title">
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </template>

            <!--            运营消息类型-->
            <template v-else>
              <div class="message-operation-warp">
                <div
                    v-for="item in data"
                    :key="item.id"
                    class="message-operation-inner"
                    :class="{'operation-read':!item.hasRead, 'operation-active':checkItem &&  item.msgIds === checkItem.msgIds }"
                    @click="changeItem(item)">

                  <div class="flex-between">
                    <span class="message-type">{{ item.warnTypeName }}</span>
                    <!--                    <span>{{ item.markName.split(':')[0] }}/{{ item.markName.split(':')[1] }}</span>-->
                    <span class="message-time">{{ item.createTime }}</span>
                  </div>

                  <div class="flex-between">
                    <span>{{ item.warnTitleName }}</span>
                  </div>

                  <div style="line-height: 18px; font-size: 12px" class="text-ellipsis-1" v-html="item.title">
                  </div>
                </div>
              </div>
              <!--              v-if="pagination.total > pagination.pageSize"-->
              <div class="message-page" v-if="pagination.total > pagination.pageSize">
                <gj-pagination
                    small
                    :background="false"
                    :layout="'prev, pager, next'"
                    :current-page.sync="pagination.currentPage"
                    :page-size.sync="pagination.pageSize"
                    :total="pagination.total"
                    @size-change="$gjNoticeQuery()"
                    @current-change="$gjNoticeQuery('page')"
                    @prev-click="$gjNoticeQuery('page')"
                    @next-click="$gjNoticeQuery('page')"
                ></gj-pagination>
              </div>
            </template>

          </template>

          <template v-else>
            <div style="width: 150px;position: relative;top: 45%;left: 35%;">
              <gj-empty></gj-empty>
            </div>
          </template>
        </div>

        <div style="flex: 1; position: relative; margin-top: 12px;"
             :style="{padding: messageType === 'system' ? 'unset' : messageType === 'operation'?'0 0 0 16px':'0 16px',
              overflowY: messageType === 'system' ? 'hidden' : 'auto'
        }"
             v-loading="detailLoading"
        >
          <template v-if="isMeaningful(checkItem)">
            <template v-if="messageType === 'system'">
              <div
                  style="position: absolute; right: 20px; top: 10px; cursor: pointer; z-index: 2003;"
                  @click="openVersionAnnouncement()">
                <gj-icon iconfont="iconfangda"></gj-icon>
              </div>
              <!--              <app-message-announcement-->
              <!--                  :data="detailData"-->
              <!--              ></app-message-announcement>-->
              <app-version-announcement-template :data="detailData"
                                                 :is-modal="false"></app-version-announcement-template>
            </template>

            <template v-else-if="messageType === 'account'">
              <app-account-message-modal
                  :data="detailData"
                  :accomplish-date="accomplishDate"
              ></app-account-message-modal>
            </template>

            <template v-else-if="messageType === 'operation'">
              <div class="flex message-header">
                <gj-area-title>{{ checkItem.warnTitleCode | switchTitle }}</gj-area-title>
                <span class="header-time">
                  (
                  <template v-if="checkItem.warnTitleCode === 'NEGATIVE_RATINGS_WARN_001'">
                    {{ checkItem.countryCode | defaultShow }}
                  </template>
                  <template v-else-if="checkItem.warnTitleCode !=='ADS_SB_REVIEW_001'">
                    {{ checkItem.markName.split(':')[0] }}/{{ checkItem.markName.split(':')[1] }}
                  </template>
                  <template
                      v-if="checkItem.warnTitleCode !== 'NEGATIVE_RATINGS_WARN_001' && checkItem.warnTitleCode !== 'NEGATIVE_RATINGS_WARN_002'">
                    {{ checkItem.createTime }}
                  </template>)</span>
              </div>

              <component
                  :is="currentComponents"
                  :warn-title-code="checkItem.warnTitleCode"
                  :data="detailData"
                  :key="currentKey"></component>

            </template>
          </template>
          <template v-else>
            <div style="width: 150px;position: relative;top: 50%;left: 50%;">
              <gj-empty text="请选择消息"></gj-empty>
            </div>
          </template>
        </div>
      </div>


    </template>
  </app-base-main>
</template>

<script>
import {isMeaningfulMixin, queryMixin, responseMixin, selectionMixin} from "../../../../minxins";
import {
  sysMsgPage,
  msgPage,
  msgdetails,
  finalPayRecordDate, batchMarkSysMessage, batchMarkAccountMessage, newVersion,
  sysUserMsg, userMsg
} from '@/api/message'
import AppAccountMessageModal from "./account-message-modal";
import {convertToFullDate} from "@/utils/date.util";
import AppMessageMonitoring from "./detail/message-monitoringandearly-warning";
import {isMeaningful} from "@/utils/common";
import AppVersionAnnouncementTemplate from "../../common/message/modal/template/version-announcement-template";
import AppVersionAnnouncement from '../../common/message/modal/version-announcement';
import {USER_SET_MESSAGE, USER_SET_STATUS} from "@/store/mutation-types";
import {WARNING_TYPE_ALL, MESSAGE_TITLE_ALL} from "@/utils/condition";
import {getOperationMessage, queryDetail, querySellWithDetail} from "@/api/warning";
import {mapGetters} from "vuex";

// 运营消息表格页面
// 商品预警
import AppOperateTableDetails from './components/operate-table-details';
// 差评预警
import AppCommentWarning from './components/comment-warning';
// 周销量
import AppWeeklySales from './components/weekly-sales';
// 政策合规性预警
import AppPolicyCompliance from './components/policy-compliance';
// A-Z预警、 Chargeback预警、Return request预警
import AppPerformanceEarly from './components/performance-early';
// 订单异常预警
import AppOrderWarn from './components/order-warn';

import {WARN_TITLE_SWITCH} from "@/utils/condition";

export default {
  name: "message-center-list",
  components: {
    AppVersionAnnouncementTemplate,
    AppAccountMessageModal,
    AppMessageMonitoring,
    AppOperateTableDetails,
    AppCommentWarning,
    AppWeeklySales,
    AppPolicyCompliance,
    AppPerformanceEarly,
    AppOrderWarn,
  },
  mixins: [queryMixin, selectionMixin, responseMixin, isMeaningfulMixin],
  inject: ['messageNewVal', 'handleMsgId'],

  filters: {
    switchTitle(val) {
      return WARN_TITLE_SWITCH[val]
    }
  },

  props: {
    messageType: {
      type: String,
      require: true,
    },
    id: null,
    inEnter: {
      type: Boolean
    }
  },

  computed: {
    ...mapGetters(['refreshMessage', 'msgNumber']),
  },

  watch: {
    messageType: {
      immediate: true,
      handler(newVal) {
        this.loading = true;
        this.$emit('query');
        this.getSysUserMsg();
      }
    },
    id: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loading = true;
          this.initParams = value;
          this.filter = {
            hasRead: false,
            countryMarketValue: {
              countryIds: [],
              marketIds: []
            },
            warnTypeCodeList: [],
            warnTitleCodeList: [],
            content: ''
          }
          this.$gjNoticeQuery();
        }
      }
    },
    refreshMessage() {
      if (this.messageType === 'operation') {
        this.$emit('query');
      }
    },
  },

  data() {
    return {
      statusFlag: false,
      checkItem: null,
      data: [],
      checkListAll: false,
      checkListIndeterminate: false,
      checkedMsg: [],
      columns: null,
      convertToFullDate: convertToFullDate,
      detailData: null,
      accomplishDate: null,
      detailLoading: false,
      markLoading: false,
      accountVisible: false,
      operationVisible: false,
      filterChecked: [],
      filterCheckedOption: [
        {id: 'TOP_UP_WARNING', text: '充值提醒'},
        {id: 'ORDER_USER_UP', text: '订单用尽提醒'},
        {id: 'SHOP_AUTH_EXPIRES', text: '店铺授权失效'},
        {id: 'ADS_STRATEGY_RESULT', text: '分时策略执行结果'}
      ],
      // [{id: 'SALE_INVENTORY', text: '高销低库存预警'},
      // {id: 'REVIEW', text: '今日差评预警'},
      // {id: 'OFFER_MONITOR_WARN', text: '跟卖监控预警'}],
      checkAll: false,
      checkIndeterminate: false,
      initParams: null,
      //  预警搜索
      filter: {
        hasRead: false,
        countryMarketValue: {
          countryIds: [],
          marketIds: []
        },
        warnTypeCodeList: [],
        warnTitleCodeList: [],
        content: ''
      },
      //  状态选择
      statusList: [
        {id: '', text: '全部'},
        {id: false, text: '未读'},
        {id: true, text: '已读'},
      ],
      warningTypeList: WARNING_TYPE_ALL,
      warningTitleList: [...MESSAGE_TITLE_ALL],
      //  存储组件
      currentComponents: null,
      //  用于更新组件的key
      currentKey: null
    }
  },

  activated() {
    if (this.checkItem.msgIds && this.messageType === 'operation' ) {
      this.data.forEach(item => {
        if(this.checkItem.msgIds === item.msgIds) {
          this.checkItem = item;
          this.queryOperationDetail(item);
        }
      })
    }
  },

  methods: {
    routerMsg(path, query) {
      this.$router.push({path: path, query: query});
    },
    clickStatus() {
      this.statusFlag = !this.statusFlag;
      this.$emit('query')
    },

    changeItem(item) {
      // 防止重复点击某条数据用也调用接口
      if (this.checkItem) {
        if (this.messageType === 'operation' && this.checkItem.msgIds === item.msgIds) {
          return;
        } else if (this.messageType !== 'operation' && this.checkItem.id === item.id) {
          return;
        }
      }
      this.checkItem = item;
      this.messageType !== 'operation' ? this.openDetail(item) : this.queryOperationDetail(item);
    },

    // 系统消息、账号消息详情
    async openDetail(row) {
      // 将详情清空
      this.detailLoading = true;
      this.detailData = null;

      let res = null;
      let response = null;
      let initRes = null;
      const isRead = row.isRead;

      // 获取系统消息（PUBLICITY）、账户信息的详情
      try {
        if (row.bizType === 'PUBLICITY') {
          res = await newVersion(row.id, !row.isRead);
        } else {
          initRes = await msgdetails(row.id, !row.isRead);
          if (initRes.isSuccess) {
            res = initRes;
            response = await finalPayRecordDate();
            this.accomplishDate = response.data;
          } else {
            this.$message.error(initRes.msg)
          }
        }
      } finally {
        this.detailLoading = false;
      }

      const {data} = res;
      this.detailData = data;
      this.checkItem.isRead = true;

      // 因为是点击查看详情就会已读，更新未读数据
      if (!isRead) {
        await this.getSysUserMsg();
      }
    },
    async $gjQuery() {
      // 当是预警的时候
      let params = {
        model: {},
        current: 1,
        size: 999999,
        order: "ascending,descending",
        sort: "isRead,createTime"
      };

      if (this.messageType === 'operation') {
        params = {
          model: {
            ...this.filter,
            ...{
              marketIdList: this.filter.countryMarketValue.marketIds,
              countryCodeList: this.filter.countryMarketValue.countryIds
            },
            hasRead: this.filter.hasRead === '' ? null : this.filter.hasRead,
            pushPro: 1
          },
          current: this.pagination.currentPage,
          size: this.pagination.pageSize
        }

        delete params.model.countryMarketValue;
      } else {
        params.model = {
          isRead: this.statusFlag
        }
      }

      // 分页查询
      this.checkItem = null;
      this.loading = true;
      let res = null;

      // 搜索数据接口
      try {
        switch (this.messageType) {
          case 'account':
            params.model.bizGroup = this.messageType;
            params.model.bizTypeList = this.filterChecked;
            res = await msgPage(params);
            break;
          case 'system':
            res = await sysMsgPage(params);
            break;
          case 'operation':
            res = await getOperationMessage(params);
            // 只要刷新了列表，就查看是否有推送弹框
            this.handleMsgId();
            // res={data:{records:[{warnTitleCode: 'NEGATIVE_RATINGS_WARN_002'}]}}
            break;
        }

        const {data} = res;
        this.data = data.records;
        if (this.messageType === 'operation') {
          this.pagination = this.getPagination(data);
        }
        this.initDetail();
      } finally {
        this.loading = false;
      }
    },
    closeFilterPopover() {
      this.accountVisible = false;
      this.operationVisible = false;
      this.$gjNoticeQuery();
    },
    initDetail() {
      if (isMeaningful(this.initParams)) {
        const filter = this.data.filter(v => this.messageType === 'operation' ? v.msgIds === this.initParams : v.id === this.initParams);
        this.initParams = null;
        if (filter.length > 0) {
          this.checkItem = filter[0];
          // 处理不同的系统账号和运营消息查看详情的情况
          this.messageType !== 'operation' ? this.openDetail(filter[0]) : this.queryOperationDetail(filter[0]);
        }
      }
    },
    checkChecked() {
      return !isMeaningful(this.checkedMsg) || this.checkedMsg.length === 0 || this.checkedMsg.some(v => v.isRead)
    },
    // changeListAll(event) {
    //   this.checkListAll = event;
    //   this.checkListIndeterminate = false;
    //   this.checkedMsg = [];
    //   if (event) {
    //     this.checkedMsg = [].concat(this.data.map(v => v.id))
    //   }
    // },
    handleCheckItem() {
      // this.checkListAll = this.data && this.data.length > 0 && this.data.every(v => this.checkedMsg.indexOf(v.id) !== -1);
      // this.checkListIndeterminate = !this.checkListAll && this.checkedMsg.length > 0;
    },
    changeAll(event) {
      this.checkAll = event;
      this.checkIndeterminate = false;
      this.filterChecked = [];
      if (event) {
        this.filterChecked = [].concat(this.filterCheckedOption.map(v => v.id))
      }
    },
    changeCheckbox() {
      this.checkAll = this.filterCheckedOption && this.filterCheckedOption.length > 0 && this.filterCheckedOption.every(v => this.filterChecked.indexOf(v.id) !== -1);
      this.checkIndeterminate = !this.checkAll && this.filterChecked.length > 0;
    },
    batchMarkMsg() {
      this.markLoading = true;
      if (this.messageType === 'system') {
        batchMarkSysMessage(this.checkedMsg.map(v => v.id))
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$gjResetPage();
                // this.getSysUserMsg();
              })
            }).complete(() => this.markLoading = false)
      } else {
        batchMarkAccountMessage(this.checkedMsg.map(v => v.id))
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$gjResetPage();
                this.getSysUserMsg();
              })
            }).complete(() => this.markLoading = false)
      }
    },
    openVersionAnnouncement() {
      this.$gjCreate(AppVersionAnnouncement, {
        global: true,
        props: {
          data: this.detailData,
        }
      })
    },

    async getSysUserMsg() {
      let res = {};
      let value = '';

      switch (this.messageType) {
          // 点击系统已读，更新数据
        case 'system':
          res = await sysUserMsg();
          value = res.data.msgNum;
          break;
          //    点击账号已读，更新数据
        case 'account':
          res = await userMsg('account');
          value = res.data.msgNum;
          break;
        case 'operation':
          res = await getOperationMessage({
            model: {hasRead: false, pushPro: 1},
            size: 6,
            current: 1
          });
          value = res.data.total;
          break;
      }

      this.$store.commit(USER_SET_MESSAGE, {type: this.messageType, value});
    },

    //  修改预警类型
    changeType(value) {
      // 通过‘_’切割并合并判断标题和表单的关联，也要考虑反选时的状态
      this.warningTitleList = MESSAGE_TITLE_ALL.filter(item => {
        let arr = item.id.split('_');
        arr.splice(arr.length - 1, 1);
        return value.indexOf(arr.join('_')) !== -1 || value.length === 0
      })

      // 只要类型发生变化，清空标题
      this.filter.warnTitleCodeList = [];
    },

    //  查看运营消息详情
    async queryOperationDetail(row) {
      let res = {};
      this.detailLoading = true;
      this.dataDetail = null;

      try {
        switch (row.warnTypeCode) {
            // 跟卖
          case 'FOLLOW_UP_WARN':
            res = await querySellWithDetail(row.msgIds);
            break;
            // 品牌广告审核
            // case 'ADS_SB_REVIEW':
            //   res = await querySellWithDetail(row.msgIds);
            //   break;
            // 其他
          default:
            res = await queryDetail(row.msgIds);
            break;
        }

        const {data} = res;
        this.getCurrentComponents(data, row.msgIds.split(',').length);

        if (!row.hasRead) {
          // const value = this.msgNumber[this.messageType] - 1;
          // this.$store.commit(USER_SET_MESSAGE, {type: this.messageType, value});
          // 如果是未读状态，则请求一下
          await this.getSysUserMsg();
        }

        // 如果成功 把状态也改成已读
        row.hasRead = true;
      } finally {
        this.detailLoading = false;
      }
      // 然后通过res.data赋值
    },

    //  匹配到对应的组件
    getCurrentComponents(data, length) {

      switch (this.checkItem.warnTitleCode) {
        case 'LISTING_WARN_001':
        case 'LISTING_WARN_002':
        case 'LISTING_WARN_003':
        case 'LISTING_WARN_004':
        case 'LISTING_WARN_005':
        case 'ADS_SB_REVIEW_001':
          this.currentComponents = 'app-operate-table-details';
          this.detailData = data.map(item => item.warn);
          break;

        case 'NEGATIVE_RATINGS_WARN_001':
        case 'NEGATIVE_RATINGS_WARN_002':
          this.currentComponents = 'app-comment-warning';
          this.checkItem.countryCode = data.length > 0 ? data[0].countryCode : null
          this.detailData = data.map(item => item.warn);
          break;

          //  周销量暴涨、周销量异常,因为周销量会有两种维度——商品（一条或者多条）、店铺（一条）
        case 'DATA_INDEX_WARN_001':
        case 'DATA_INDEX_WARN_003':
          if (data[0].warn.warnDimension === 'market') {
            this.currentComponents = 'app-performance-early';
            this.detailData = data[0].warn;
          } else {
            this.currentComponents = 'app-weekly-sales';
            this.detailData = data.map(item => item.warn);
          }
          break;

          //  日销量暴涨、日销量异常
        case 'DATA_INDEX_WARN_002':
        case 'DATA_INDEX_WARN_004':
          this.currentComponents = 'app-weekly-sales';
          this.detailData = data.map(item => item.warn);
          break;

          // 政策合规性
        case 'MARKET_PERFORMANCE_WARN_005':
          this.currentComponents = 'app-policy-compliance';
          this.detailData = data[0].warn;
          break;

          //  A-Z预警、Chargeback预警、客户服务绩效异常预警、Return request预警、配送绩效异常预警
        case 'MARKET_PERFORMANCE_WARN_004':
        case 'MARKET_PERFORMANCE_WARN_001':
        case 'MARKET_PERFORMANCE_WARN_002':
        case 'MARKET_PERFORMANCE_WARN_003':
        case 'MARKET_PERFORMANCE_WARN_006':
          this.currentComponents = 'app-performance-early';
          this.detailData = data[0].warn;
          this.detailData.dataLength = length;
          break;

          // 配送费异常
        case 'ORDER_WARN_001':
          this.currentComponents = 'app-order-warn';
          this.detailData = data.map(item => item.warn);
          break;

          // 跟卖监控
        case 'FOLLOW_UP_WARN_001':
          this.currentComponents = 'app-message-monitoring';
          this.detailData = data;
          break;
      }
      this.currentKey = Date.now();
    }
  }
}
</script>

<style scoped lang="scss">
.message-content {
  cursor: pointer;
  width: 100%;
}

.message-content:hover {
  color: #1F6EEF;
}

.filter {
  color: #909399;
  font-size: 12px;
}

.filter-a {
  color: #1F6EEF;
  cursor: pointer;
  font-size: 12px;
}

.iconfont-style {
  font-size: 20px;
  color: #666;
  margin-right: 6px;
  cursor: pointer;
}

.label {
  color: #666;
  font-size: 13px;
}

.list-item {
  display: flex;
  border-bottom: 1px solid #ddd;
  flex-direction: row;
  width: 100%;
  cursor: pointer;
}

.list-item:hover {
  background: #f2f2f2;
}

.list-checkbox {
  width: 14px;
  padding: 10px;
  border-right: 1px solid #ddd;
}

.list-content {
  padding: 6px 0;
  flex: 1;
}

.read-radio {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 8px;
  background-color: #ddd;
}

/deep/ .el-checkbox-group {
  font-size: 14px;
}

.list-item /deep/ .el-checkbox__label {
  display: unset;
  padding-left: unset;
  line-height: unset;
  font-size: unset;
}

/deep/ .parent-table {
  display: flex;
  flex-direction: column;
}

.border {
  border: 1px solid #ddd;
}

.message-warp {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: auto;
  flex: 1;
  //border: 1px solid #ddd;
  box-sizing: border-box;

  .message-middle {
    width: 410px;
    border-right: 1px solid #ddd;
  }

  .message-account {
    overflow-y: auto;
  }

  .message-operation {
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .message-page {
      text-align: right;
      padding-right: 10px;
      margin-top: 8px;
    }

    .message-operation-warp {
      padding-right: 4px;
      overflow-y: auto;
      //height: 100%;
      flex: 1;

      .message-operation-inner {
        background: #FAFAFA;
        height: 78px;
        margin-bottom: 10px;
        padding: 8px 8px 8px 28px;
        box-sizing: border-box;
        border-left: 3px solid #FAFAFA;
        color: #333;
        cursor: pointer;

        .flex-between {
          display: flex;
          height: 18px;
          margin-bottom: 4px;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;

          .message-type {
            font-weight: 600;
          }

          .message-time {
            color: #999;
          }
        }
      }

      .operation-read {
        position: relative;

        &::after {
          position: absolute;
          content: '';
          display: block;
          top: 0;
          right: 0;
          border-right: 7px solid #1c63d7;
          border-top: 7px solid #1c63d7;
          border-left: 7px solid transparent;
          border-bottom: 7px solid transparent;
        }
      }

      .operation-active {
        border-left: 3px solid #1c63d7;
        background: #EEF3FB;
      }
    }
  }

  .message-header {
    //margin: 12px 0 0 0;
    line-height: 19px;

    .header-time {
      font-size: 12px;
      color: #999;
      margin-left: 20px;
    }
  }
}
</style>
